import {Component} from '@angular/core';
import {environment} from "../environments/environment";
import { SdkAnalyticsService } from './shared/services/analytics/sdk-analytics.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
})
export class AppComponent {

  constructor(private sdkAnalytics: SdkAnalyticsService) {
    this.trackInfo()
     this.removeLogs();
  }

  private getConfigSdk() {
    const baseConfig = environment.configDataDog;
    return baseConfig;

  }


  async trackInfo() {


    const trackData = {
      analytics: {
        event_name: 'log',
        parameters: {
          status: 'info',
          message: `teste info`,
          context: {
              error: 'teste'
          },
        },
      },
    };

    const configSdk = this.getConfigSdk();

    await this.sdkAnalytics
      .track(configSdk, trackData)
      .catch((e: any) =>
        console.error('Falha ao enviar log para DataDog:', e),
      );
  }

  removeLogs(): void {

      window.console.log = () => {
      };
      window.console.info = () => {
      };

  }

}
